<template>
  <div class="menu">
    <div class="header-banner">
      <BannerOne title="Confirm Order" />

      <div class="container" v-if="this.orderSubmitted">
        <div class="extra-charge">Saving Order, Please Wait!</div>
      </div>

      <div class="container" v-if="!this.orderSubmitted">
        <div class="extra-charge" v-if="this.gotError">
          Delivery Charge of Rs. {{ this.delCharge }} will be added based on
          your provided location.
        </div>

        <div
          class="extra-charge"
          v-if="!this.gotError && !this.gotLocationError"
        >
          Please Wait! Fetching delivery charge.
        </div>

        <div class="extra-charge" v-if="this.gotLocationError">
          {{ this.errorMessage }}
        </div>

        <div class="total-price" v-if="this.gotError || this.gotLocationError">
          Total Amount : NRs
          {{ this.cartTotal + this.delCharge }}
        </div>

        <div
          class="custom-button-wrap"
          v-if="this.gotError || this.gotLocationError"
        >
          <button class="custom-button green" @click="confirmOrder()">
            Confirm Order
          </button>

          <!-- <router-link to="/checkout">
            <div class="cancel-button ">Cancel Order</div>
          </router-link> -->

          <div class="cancel-button" @click="cancelOrder()">Cancel Order</div>

          <!-- <router-link to="/paymentmethod">
            <div class="cancel-button ">Payment</div>
          </router-link> -->

          <!-- <router-link to="/esewa/success">
            <div class="custom-button green ">Esewa Failed</div>
          </router-link>

          <router-link to="/esewa/failure">
            <div class="custom-button green ">Esewa Success</div>
          </router-link> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src\
import { LocationId, CartData } from "../../services/storage.service";
import { mapGetters, mapActions } from "vuex";
import router from "../../router";

import BannerOne from "../../components/BannerOne.vue";
import axios from "axios";

export default {
  name: "ConfirmOrder",
  data() {
    return {
      delCharge: 0,
      gotError: false,
      gotLocationError: false,
      errorMessage: "",
      orderSubmitted: false,
    };
  },
  created() {
    window.scrollTo(0, 0);
  },
  components: {
    BannerOne,
  },
  computed: {
    ...mapGetters(["locationMarker", "cartTotal"]),
  },
  methods: {
    ...mapActions(["submitOrder"]),

    confirmOrder() {
      this.orderSubmitted = true;
      this.submitOrder(this.delCharge);
    },

    cancelOrder() {
      router.push("/p/checkout");
    },

    getDeliveryCharge() {
      axios
        .post("https://manager.khaanpin.com/apiv2/getdeliverycharge/", {
          loc_id: LocationId.getLocationId(),
          location: "https://www.google.com/maps/place/" + this.locationMarker,
        })
        .then((response) => {
          if (response.data.error === true) {
            console.log("error in response", response.data);
            this.gotError = false;
            this.gotLocationError = true;
            this.errorMessage = response.data.data;
          } else {
            CartData.setDeliveryCharge(response.data.data);
            this.delCharge = response.data.data;
            this.gotError = true;

            // console.log("delivery charge set", response.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },

  beforeMount() {
    this.getDeliveryCharge();
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
.container {
  display: flex;
  height: 300px;
  justify-content: center;
  flex-direction: column;
}

.custom-button-wrap {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  margin-top: 30px;
  .custom-button {
    &.green {
      background: #60b246;
      border-color: #60b246;
      &:hover {
        background: #fff;
        border-color: gray;
      }
    }
    &.hide {
      display: none;
    }
  }

  .cancel-button {
    text-decoration: underline;
    color: #000;
    font-size: 12px;
    margin-top: 20px;
    cursor: pointer;
  }
}

.extra-charge {
  margin-top: 40px;
  color: $brand-color;
  font-weight: 600;
  font-family: $main-font;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
}

.total-price {
  margin-top: 40px;
  color: $brand-color;
  font-weight: 800;
  font-family: $main-font;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
}
</style>
